export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-section-offset">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">关于我们</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-4">了解黑料吃瓜的定位、使命与核心价值</p>

        <div className="max-w-3xl bg-background-100 rounded-xl border border-background-200/60 p-6 md:p-8">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            黑料吃瓜是一个专注于娱乐八卦与热点爆料聚合的中文内容平台。我们聚合了51黑料吃瓜、91黑料吃瓜、17黑料吃瓜等多个数字版本的优质内容，
            为用户提供一站式的爆料浏览体验。
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            平台始终坚持内容为王的理念，持续追踪黑料吃瓜52、黑料吃瓜92、黑料吃瓜18等热门线路的最新动态，
            确保用户能够通过我们找到最新、最全的娱乐资讯。无论您关注的是明星八卦、综艺内幕还是网红翻车现场，
            黑料吃瓜都是您获取第一手爆料的最佳入口。
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            我们致力于打造安全、便捷、免费的内容聚合服务，通过多线路备份和HTTPS加密传输，
            为用户提供稳定可靠的访问体验。黑料吃瓜数字版线路选择功能帮助用户快速找到最优访问路径，
            是数百万网友日常追更爆料的必备工具。
          </p>
        </div>
      </div>
    </section>
  );
}